var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCurveBlock = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 959.192 924.844",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5003 1230.781v-924.181h959.192v193.54s-1095.805-626.872-875.708 730.645c-42.684 1.481-83.484-.004-83.484-.004z",
    fill: "currentColor",
    transform: "translate(-5003 -306.597)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCurveBlock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/curve-block.0b29a606.svg";
export { ForwardRef as ReactComponent };